import React from "react";
import { Spin } from "antd";
import NoDataAvailable from "./NoDataAvailable";

const StatusCard = ({ title, status }) => (
  <div
    style={{
      textAlign: "center",
      padding: "15px",
      border: "1px solid #E8E8E8",
      borderRadius: "8px",
      cursor: "pointer",
      transition: "all 0.3s ease",
      boxShadow: "0 2px 4px rgba(0, 0, 0, 0.05)",
      //   backgroundColor: "#FAFAFA",
    }}
    className="status-card"
  >
    <p
      style={{
        fontSize: "15px",
        fontWeight: "500",
        color: "#8C8C8C",
        marginBottom: "8px",
      }}
    >
      {title}
    </p>
    <span
      style={{
        backgroundColor: getTagColor(status),
        color: "white",
        padding: "6px 16px",
        borderRadius: "16px",
        fontSize: "14px",
        fontWeight: "500",
      }}
    >
      {status}
    </span>
  </div>
);

// Reusable Breakdown Item Component
const BreakdownItem = ({ count, label, color }) => (
  <div
    style={{
      textAlign: "center",
    }}
  >
    <p
      style={{
        fontSize: "32px",
        fontWeight: "bold",
        color: color,
        margin: "0",
        lineHeight: "1",
      }}
    >
      {count}
    </p>
    <p
      style={{
        fontSize: "14px",
        fontWeight: "bold",
        color: "#8C8C8C",
        margin: "5px 0 0 0",
      }}
    >
      {label}
    </p>
  </div>
);

const OverallComplianceStatus = ({ labAnalyticsDetails, isLoading }) => {
  
  const { sampleComplianceDetails } = labAnalyticsDetails || {};
  const statusCards = [
    {
      title: "Overall Compliance",
      status: sampleComplianceDetails?.overallSampleClassification || "N/A",
    },
    {
      title: "Safety",
      status: sampleComplianceDetails?.overallSafetyCompliant || "N/A",
    },
    {
      title: "Quality",
      status: sampleComplianceDetails?.overallQualityCompliant || "N/A",
    },
    {
      title: "Labelling",
      status: sampleComplianceDetails?.overallLabellingCompliant || "N/A",
    },
  ];

  // Breakdown data
  const breakdownData = [
    {
      count: sampleComplianceDetails?.safeCount || 0,
      label: "Safe",
      color: "#47b510ff",
    },
    {
      count: sampleComplianceDetails?.unsafeCount || 0,
      label: "Unsafe",
      color: "#c61215ff",
    },
    {
      count: sampleComplianceDetails?.standardCount || 0,
      label: "Standard",
      color: "#42a710ff",
    },
    {
      count: sampleComplianceDetails?.subStandardCount || 0,
      label: "Sub-Standard",
      color: "#d3730bff",
    },
  ];

  return (
    <div
      style={{
        padding: "20px 30px",
        border: "1px solid #E0E0E0",
        borderRadius: 8,
        backgroundColor: "#fff",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div style={{ flex: 1 }}>
        <p
          style={{
            fontWeight: "bold",
            fontSize: 16,
            paddingBottom: "5px",
            borderBottom: "1px solid #D9D9D9",
            marginBottom: "20px",
          }}
        >
          Overall Compliance Status
        </p>


        {isLoading ? (
          <div style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "200px",
            flexDirection: "column"
          }}>
            <Spin />
            <p style={{
              marginTop: "16px",
              fontSize: "14px",
              color: "#8C8C8C"
            }}>Loading compliance data...</p>
          </div>
        ) : !sampleComplianceDetails ? (
          <NoDataAvailable
            title="No Compliance Data Available"
            description="Compliance status will appear here once data is available"
            height="200px"
          />
        ) : (
          <>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(4, 1fr)",
                gap: "20px",
                marginBottom: "30px",
              }}
            >
              {statusCards.map((card, index) => (
                <StatusCard
                  key={index}
                  title={card.title}
                  status={card.status}
                />
              ))}
            </div>
            <div
              style={{
                padding: "20px",
                border: "1px solid #E8E8E8",
                borderRadius: "8px",
                backgroundColor: "#fafcfd",
              }}
            >
              <p
                style={{
                  fontWeight: "bold",
                  fontSize: "16px",
                  marginBottom: "20px",
                  textAlign: "center",
                }}
              >
                Compliance Breakdown
              </p>

              <div
                style={{
                  display: "grid",
                  gridTemplateColumns: "repeat(4, 1fr)",
                  gap: "20px",
                  textAlign: "center",
                }}
              >
                {breakdownData.map((item, index) => (
                  <BreakdownItem
                    key={index}
                    count={item.count}
                    label={item.label}
                    color={item.color}
                  />
                ))}
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default OverallComplianceStatus;

const getTagColor = (status) => {
  switch (status) {
    case "Safe":
    case "Compliant":
    case "Standard":
      return "#46B011"; // green
    case "Non-Compliant":
    case "Unsafe":
      return "#EE1A1D"; // red
    case "Not Applicable":
      return "#D4A545"; // yellow/golden
    case "Branded":
      return "#1B63A6"; // blue
    case "Mislabeled":
      return "#8C8C8C"; // gray
    case "Sub-standard":
      return "#FF7F27"; // orange
    default:
      return "#8C8C8C"; // fallback gray
  }
};